import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    cardWrapper: {
        padding: theme.spacing(5.5),
    },
}));
